import React, { useEffect } from "react";
import SlideOutSidebar from "../../../ui-components/slide-out-sidebar/slideOutSidebar";
import PickupForm from "../../common/pickup-form";
import { mapToPickupConsigneeModel, mapToPickupItemsModel, mapToPickupShipperModel } from "../../../services/pickups";
import { useDispatch } from "react-redux";
import { setShippers, setShipper, updatePickupNumber, setTeamName, setConsignee, setConsigneeCheckResult, setPickupId, setItems } from "../../../slices/pickup/pickupSlice";
import { transformAddress } from "../../../services/common/address";
import { PickupsResponseContentModel } from "../../../app/data/pickup/models";

export interface PickupEditProps {  
  onClose: () => void;
  onSuccess: (pickup: PickupsResponseContentModel) => void;
  isOpen: boolean;
  pickup: PickupsResponseContentModel | null;
};

const PickupEdit: React.FC<PickupEditProps> = ({ isOpen, onClose, onSuccess, pickup }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!pickup || !isOpen) return;

    const shipperStepFormData = mapToPickupShipperModel(pickup);
    dispatch(setShippers([{
      ...shipperStepFormData.shipper,
      address: transformAddress(shipperStepFormData.shipper.address),
    }]));
    dispatch(setTeamName(shipperStepFormData.teamName));
    dispatch(setShipper(shipperStepFormData));

    dispatch(setConsignee(mapToPickupConsigneeModel(pickup)));
    dispatch(setConsigneeCheckResult(true));

    dispatch(setItems(mapToPickupItemsModel(pickup)));

    dispatch(setPickupId(pickup.pickup.pickupId));
    dispatch(updatePickupNumber(pickup.pickup));
  }, [dispatch, pickup, isOpen]);

  return (
    <SlideOutSidebar
      header="Pending Pickup Editing"
      onClose={onClose}
      show={isOpen}
      size="small"
    >
      <PickupForm key={isOpen.toString()} editMode={true} onSuccess={onSuccess}/>
    </SlideOutSidebar>
  );
};

export default PickupEdit;
